module.exports = __webpack_public_path__ + "static/media/old baker-steel-gold-i.6c9a4089.csv";